exports = module.exports = require("../../../../../../develop/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dropbox[data-v-41d95bf3]{outline:2px dashed grey;outline-offset:-10px;color:dimgray;padding:-10px 10px;min-height:20px;height:70px;position:relative;cursor:pointer;margin-top:-20px;font-size:10px}.dropbox-light[data-v-41d95bf3]{background:#e0ffff}.input-file[data-v-41d95bf3]{opacity:0;width:100%;height:80px;cursor:pointer}.dropbox[data-v-41d95bf3]:hover{background:#add8e6}.dropbox p[data-v-41d95bf3]{font-size:1.2em;text-align:center;margin-top:-80px;width:600px;height:80px;padding:15px 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /Users/gtirby/develop/~/css-loader?minimize!/Users/gtirby/develop/~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-41d95bf3","scoped":true,"hasInlineConfig":false}!/Users/gtirby/develop/~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/PDFChecks.vue
// module id = 369
// module chunks = 0